import moment from 'moment'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import SelectField from '../../../FormLegacy/FormFieldsV2/SelectField'
import Icon from '../../../Icons'

const getFilteredOptions = (startTime, options) => {
  const startHour = 7
  const endHour = 20

  return options.map((option) => {
    const [num, unit] = option.value.split(' ')
    const duration = moment.duration(Number(num), unit)
    const reminderTime = moment(startTime).subtract(duration)
    const hour = reminderTime.hour()

    option.disabled = hour < startHour || hour > endHour
    return option
  })
}

const TimeSelectInput = ({ summary, value, handleFieldChange, startTime, name, options }) => {
  const { t } = useTranslation(['create-event'])
  const timeOptions = getFilteredOptions(startTime, options)
  return (
    <div className="reminder-time-input">
      <div className="header">{t('create-event:timeSelectInput.whenWouldYouLikeToSend')}</div>
      <div className="nighthours-info">
        <div>
          <Icon
            icon="exclamationPoint"
            viewBox="0 0 20 20"
            styles={{
              position: 'static',
              width: '15px',
              height: '15px',
              marginTop: '4px',
              marginRight: '5px',
            }}
            fill="#b10000"
          />
        </div>
        <div>{t('create-event:timeSelectInput.nighttimeHoursDisabled')}</div>
      </div>
      <SelectField
        options={timeOptions}
        name={name}
        value={value}
        onChange={handleFieldChange}
        selectStyle={{ width: '100%' }}
        renderRightElement={(opt) =>
          opt.disabled && (
            <Icon
              icon="exclamationPoint"
              viewBox="0 0 20 20"
              styles={{ position: 'static' }}
              fill="#b10000"
            />
          )
        }
      />
      <div className="summary">
        <strong>{t('create-event:timeSelectInput.summaryLabel')}</strong> {summary}
      </div>
    </div>
  )
}

TimeSelectInput.propTypes = {
  summary: PropTypes.string,
  value: PropTypes.string,
  handleFieldChange: PropTypes.func,
  startTime: PropTypes.object,
  name: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.object),
}

export default TimeSelectInput
